import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 bg-forest text-cream" data-id="element-84">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-86">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-forest-400/30 text-cream-200 text-sm font-bold tracking-wide uppercase mb-8" data-id="element-87">
            <ShieldCheck size={18} data-id="element-88" />
            <span data-id="element-89">El Mecanismo Único</span>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-cream-50 mb-8 leading-tight" data-id="element-90">
            El Método de Reinicio Inmunitario de 14 Días
          </h2>

          <p className="text-xl md:text-2xl text-forest-100 leading-relaxed font-serif" data-id="element-91">
            Este sistema no es una "cura mágica", es un protocolo biológico que
            vacía sistemáticamente la carga tóxica de tu perro. Mediante la
            eliminación selectiva de gatillos y el uso de "suplementos de
            cocina", le damos permiso al sistema inmune para que deje de atacar
            y comience a reparar.
          </p>
        </motion.div>
      </div>
    </section>;
}